export default {
  de: {
    title: 'Benutzer',
    control: 'Steuerung',
    steering: 'Lenkung',
    coaching: 'Coaching',
    watching: 'Beobachter',
  },
};
